




































 import {Component, Vue} from "vue-property-decorator";
 import {MutationList as ModalMutations} from "@/store/modules/modal/mutation-list";

 @Component
 export default class SmallModalMessage extends Vue {

     private modalNamespace = 'modal/';

     get visibility(): boolean{
         return this.$store.getters[`${this.modalNamespace}isVisibleSmallMessage`]
     }

     get title(): string {
         return this.$store.getters[`${this.modalNamespace}getSmallModalTitle`]
     }

     get message(): string {
         return this.$store.getters[`${this.modalNamespace}getSmallModalMessage`];
     }

     closeMessage(){
         this.$store.commit(`${this.modalNamespace}${ModalMutations.SET_SMALL_MODAL_MESSAGE_VISIBLE_FALSE}`)
     }
}
